import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("livyvio_token");
    if (!token) { setLoading(false); return; }
    api.get("/api/auth/me")
      .then(({ data }) => setUser(data.user))
      .catch(() => localStorage.removeItem("livyvio_token"))
      .finally(() => setLoading(false));
  }, []);

  async function login(email, password) {
    const { data } = await api.post("/api/auth/login", { email, password });
    localStorage.setItem("livyvio_token", data.token);
    setUser(data.user);
    return data.user;
  }

  async function register(name, email, password) {
    const { data } = await api.post("/api/auth/register", { name, email, password });
    localStorage.setItem("livyvio_token", data.token);
    setUser(data.user);
    return data.user;
  }

  function logout() {
    localStorage.removeItem("livyvio_token");
    setUser(null);
  }

  const isStaff = user && (user.role === "admin" || user.role === "editor");

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, isStaff, formatApiError }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
